export const CREATE_RESUME = "CREATE_RESUME_REQUEST";
export const CREATE_RESUME_SUCCESS = "CREATE_RESUME_SUCCESS";
export const CREATE_RESUME_ERROR = "CREATE_RESUME_ERROR";
